
    import React from 'react';
    import ReactDOM from 'react-dom';
    import Component from '/home/circleci/app/node_modules/.pnpm/@fiverr-private+categories_menu@4.9.0_babel-plugin-macros@3.1.0_encoding@0.1.13_react@17.0.2/node_modules/@fiverr-private/categories_menu/src/index';

    const element = typeof document !== 'undefined' && document.querySelector('#LayoutCategoriesMenuComponent-component');

    if (element) {
        const props = window.initialData['LayoutCategoriesMenuComponent'];

        ReactDOM.render(
            <Component {...props}/>,
            element
        );
    }

    export default Component;
    